import {IOfferLeftPropertiesStats} from "../../../offer/types/IOfferLeftPropertiesStats";
import {BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD} from "../../constants/booster_offer_stats";

export const areOfferLeftPropertiesStatsValid = (stats?: IOfferLeftPropertiesStats | null): boolean => {
    return (
        !!stats &&
        typeof stats.left === "number" &&
        typeof stats.total === "number" &&
        stats.left > 0 &&
        stats.left <= BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD &&
        stats.total > BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD
    );
};
import {IOfferLeftPropertiesStats} from "../../../offer/types/IOfferLeftPropertiesStats";
import {BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD} from "../../constants/booster_offer_stats";

export const areOfferLeftPropertiesStatsValid = (stats?: IOfferLeftPropertiesStats | null): boolean => {
    return (
        !!stats &&
        typeof stats.left === "number" &&
        typeof stats.total === "number" &&
        stats.left > 0 &&
        stats.left <= BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD &&
        stats.total > BOOSTER_OFFER_STATS_ONE_OF_LAST_THRESHOLD
    );
};
